import React from 'react'
import styles from './statusTag.module.scss'
import { MatchUpStatusEnum } from 'types/global'

const TAGS = {
  WALKOVER: { code: 'WO', label: 'Walkover' },
  SUSPENDED: { code: 'SUS', label: 'Suspended' },
  RETIRED: { code: 'RET', label: 'Retired' },
  ABANDONED: { code: 'ABN', label: 'Abandoned' },
  DEFAULTED: { code: 'DEF', label: 'Defaulted' },
  DISQUALIFIED: { code: 'DEF', label: 'Defaulted' },
  DEAD_RUBBER: { code: 'DR', label: 'Dead rubber' },
}

interface Props {
  status: MatchUpStatusEnum
}

const StatusTag = ({ status }: Props) => {
  const tag = TAGS[status]
  if (!tag) return null
  return (
    <span className={styles.tag} title={tag.label}>
      {tag.code}
    </span>
  )
}

export default StatusTag
